import Button from 'components/button'
import textServices from 'services/text-services'
import { useSession } from 'contexts/session-context'
import useMainClass from 'hooks/use-main-cass'
import { PrizesCouponType } from 'types/prizes.d'
import { TextButton3 } from 'theme/congrats'
import { Link } from 'react-router-dom'
import {
  ExchangeContainerModal,
  ExchangeContainerText,
  ExchangeContainerTop,
  ExchangeImage,
  ExchangePointsContainer,
  ExchangePointsText,
} from './styles'
// import ScratchView from './scrachView'

interface IProps {
  item: {
    points?: number
    title: string
    imageUrl?: string
    stickerId?: number
    couponTypeId?: PrizesCouponType
    thirdImageUrl?: string
  }
  title?: string | JSX.Element
  description?: string | JSX.Element
  buttons: {
    text?: string
    dontShowButtons?: boolean
    handleButtonSticker?: () => void
    handleButtonCommon?: () => void
  }
  buttonSecondary?: {
    hidden?: boolean
    onClick?: (event?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
    text: string
    url: string
  }
  buttonTertiary?: {
    onClick?: (event?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
    hidden?: boolean
    text: string
    url: string
  }
  module?: string
  name?: string
  time?: number
  useRanking?: boolean
  className?: string
}

function formatTime(ms: number) {
  const totalSeconds = Math.floor(ms / 1000)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  const formattedMinutes = minutes.toString().padStart(2, '0')
  const formattedSeconds = seconds.toString().padStart(2, '0')

  return `${formattedMinutes}m ${formattedSeconds}s`
}

function PopUpExchangeV2({
  item,
  time,
  useRanking,
  title,
  description,
  buttons,
  module,
  name,
  buttonSecondary,
  buttonTertiary,
  className
}: IProps) {
  const [{ user }] = useSession()
  useMainClass(`exchange`)
  useMainClass(`${module}__exchange`)

  // if (item?.couponTypeId === PrizesCouponType.SCRATCH)
  //   return <ScratchView item={item} buttons={buttons} module={module} />

  return (
    <ExchangeContainerModal
      className={`flex-1 pb-6 space-y-8 flex flex-col justify-between w-full sm:max-w-sm ${className}`}
    >
      <ExchangeContainerTop className="flex-1 flex flex-col gap-6 items-center justify-center w-full">
        <ExchangeContainerText className="w-full space-y-8">
          <h2 className='exchange__title title medium text-center'>
            {title || (
              <>
                ¡{textServices.findByText(`${module}/exchange/title`, { es: 'Veeeeenga', en: 'Come on' })} {user?.firstName ?? name}!
              </>
            )}
          </h2>
          {useRanking && (
            <div className="w-full flex flex-col gap-1 items-center text-center mb-3 exchange_time">
              <p className="text small">Tardaste:</p>
              <p className="border border-solid w-full px-3 py-3 flex items-center justify-center rounded-sm description medium time">
                <b>{formatTime(time)}</b>
              </p>
            </div>
          )}
          <p className='text big text-center exchange__description' style={(item?.couponTypeId === 0 && item?.title !== 'MALA SUERTE') ? { margin: '10px', fontSize: '20px' } : {}}>
            {description || (
              <>
                {textServices.findByText(
                  `${module}/exchange/description`,
                  { es: 'Ganaste', en: 'You won' },
                  { POINTS_COUNT: `${item?.points}` }
                )}{' '}
                <b>
                  {' '}
                  <br /> {item?.points <= 0 && item?.title}
                </b>
              </>
            )}
          </p>
        </ExchangeContainerText>
        {item?.imageUrl ? (
          <ExchangeImage src={item?.couponTypeId === PrizesCouponType.STICKER ? (item?.thirdImageUrl ?? item?.imageUrl) : item?.imageUrl} alt={item?.title} style={(item?.couponTypeId === 0 && item?.title !== 'MALA SUERTE') ? { background: 'rgba(255, 255, 255, 0.5)', width: '30%', borderRadius: '8px', padding: '20px 10px' } : {}} />
        ) : item?.points ? (
          <ExchangePointsContainer
            className="w-48 h-48 flex justify-center items-center mx-auto text-center exchange_points_crown"
            style={{ backgroundSize: 'contain' }}
          >
            <ExchangePointsText className="text-4xl font-bold mx-auto">
              {item?.points}
              <br /> <span className="uppercase">{POINTS_NAME}</span>
            </ExchangePointsText>
          </ExchangePointsContainer>
        ) : (
          <></>
        )}
      </ExchangeContainerTop>
      <div className='space-y-2 flex flex-col'>
        {!buttons?.dontShowButtons && (
          <Button onClick={item?.stickerId > 0 ? buttons?.handleButtonSticker : buttons?.handleButtonCommon}>
            {buttons?.text ??
              textServices.findByText(`${module}/exchange/button/text`, {
                es: item?.stickerId > 0 ? 'VER MIS SELLOS' : 'VER MIS PREMIOS',
                en: item?.stickerId > 0 ? 'SEE MY SEALS' : 'SEE MY AWARDS'
              })}
          </Button>
        )}
        {!buttonSecondary?.hidden && buttonSecondary?.url && (
          <Link to={buttonSecondary?.url} onClick={(e) => buttonSecondary?.onClick ? buttonSecondary?.onClick(e) : null} className='button-secondary'>
            {buttonSecondary?.text}
          </Link>
        )}
        {!buttonTertiary?.hidden && buttonTertiary?.url && (
          <Link type="button" to={buttonTertiary?.url} onClick={(e) => buttonTertiary?.onClick ? buttonTertiary?.onClick(e) : null} className="cursor-pointer">
            <TextButton3 className={`din text-center uppercase underline pt-2`} style={{ fontSize: 10 }}>
              {buttonTertiary?.text}
            </TextButton3>
          </Link>
        )}
      </div>
    </ExchangeContainerModal>
  )
}

export default PopUpExchangeV2
